import { solidRouterAdapter } from "@gyoll/adapter-solid-router";
import { initFileRoutes } from "@gyoll/runtime";
import { render } from "solid-js/web";

import { I18nProvider } from "@uic/adapters/i18n";
import { AuthnProvider } from "@uic/domain/authn";
import { OrganizationsProvider } from "@uic/domain/organizations";

import { routes } from "./gyoll-manifest";

const SEASONAL_THEMES = [
  "winter",
  "winter",
  "spring",
  "spring",
  "spring",
  "summer",
  "summer",
  "summer",
  "autumn",
  "autumn",
  "autumn",
  "winter",
];

/**
 * Sets the theme based on the current month and color scheme preference,
 * and listens for OS-level light/dark changes.
 */
function applySeasonalTheme() {
  const darkQuery = window.matchMedia("(prefers-color-scheme: dark)");
  const season = SEASONAL_THEMES[new Date().getMonth()];

  /**
   *
   */
  function setTheme() {
    const theme = darkQuery.matches ? `${season}-dark` : season;
    document.documentElement.setAttribute("data-theme", theme);
  }

  setTheme();
  darkQuery.addEventListener("change", setTheme);
}

/**
 * This is the entry point for the client-side application.
 * @returns {void}
 * @throws {Error} If the root element is not found in the DOM
 */
async function main() {
  applySeasonalTheme();
  const GyollSolidRouter = await initFileRoutes({
    routes,
    adapter: solidRouterAdapter,
  });

  const container = document.getElementById("uic");
  const dispose = render(
    () => (
      <I18nProvider>
        <AuthnProvider>
          <OrganizationsProvider>
            <GyollSolidRouter />
          </OrganizationsProvider>
        </AuthnProvider>
      </I18nProvider>
    ),
    container,
  );

  if (import.meta.hot) {
    import.meta.hot.dispose(() => {
      dispose();
    });
  }
}

main();
